import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RequirementTableHeader } from '../../../components/datagrid/EmployeeService/Requirement/RequirementTableHeader';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import ActionDetails from '../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../components/mui/GlobalAnchor/GlobalAnchorList';
import { Autocomplete, Box, Grid, Paper, TextField, Typography } from '@mui/material';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import {
  getAllCategoryNoLimit,
  getAllDepartments,
  getAllProductsWithoutPagination,
  getAllSubCatWithNoLimit,
  getAllVendorsWithoutPagination,
  getCategoryTypesNoLimit,
  getSale,
  getUsersUnderDepartment,
} from '../../../redux/features/assetManagementSlice';
import VerifyAndSale from './VerifyAndSale';
import HandTheProductBack from './HandTheProductBack';
import DeliveryDate from './DeliveryDate';
import ProcureHeadApproval from './ProcureHeadApproval';
import ProcureHeadReject from './ProcureHeadReject';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { savePaginationData } from '../../../redux/features/globalDatagridSlice';
import { debounce } from 'lodash';
import ChangeUser from './ChangeUser';
import ChangeDeliveredProduct from './ChangeDeliveredProduct';
import apiRequest from '../../../api/request';
import { getPaginationUrl } from '../../../utils/constants/GetPaginationURL';
const productStatus = [
  { id: -1, name: 'All' },
  { id: 1, name: 'Damaged' },
  { id: 0, name: 'Not Damaged' },
];
const approvalStatuses = [
  { id: -1, name: 'All' },
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Approved' },
  { id: 2, name: 'Rejected' },
];
const deliveryStatuses = [
  { id: -1, name: 'All' },
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Delivered' },
  { id: 2, name: 'Returned' },
];
const SaleView = () => {
  const cred = JSON.parse(localStorage.getItem('cred') || '{}');
  const isReportingHeadFromToken = cred?.profile?.isReportingHead;
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData } = paginationData;
  const [typeId, setTypeId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [subCatId, setSubCatId] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [poductSts, setProductSts] = useState({});
  const [approvalSts, setApprovalSts] = useState(isReportingHeadFromToken ? { id: 0, name: 'Pending' } : {});
  const [deliverySts, setDeliverySts] = useState(!isReportingHeadFromToken ? { id: 0, name: 'Pending' } : {});
  const [departmentId, setDepartmentId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [currentRowDetails, setCurrentRowDetails] = useState(null);
  const isResettingPage = useRef(false);
  const {
    loading,
    saleDetails,
    categoryAllData,
    categoryTypesNoLimit,
    allSubCatData,
    vendorData,
    departments,
    usersUnderDepartment,
  } = useSelector((store) => store.assetmanagement);
  const dispatchParams = {
    paginationData,
    isAssetManagement: true,
    typeId,
    categoryId,
    subCatId,
    vendorId,
    search,
    damageStatus: poductSts?.id == undefined || poductSts?.id == -1 ? null : poductSts?.id,
    deliveryStatus: deliverySts?.id == undefined || deliverySts?.id == -1 ? null : deliverySts?.id,
    approvalStatus: approvalSts?.id == undefined || approvalSts?.id == -1 ? null : approvalSts?.id,
    departmentId,
    userId,
  };

  //..................IT IS DEPENDECY FOR PAGE RESET TO PAGE NUMBER 1......................///
  useEffect(() => {
    isResettingPage.current = true;
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [search, typeId, categoryId, subCatId, vendorId, poductSts, approvalSts, deliverySts, departmentId, userId]);
  //........................................///

  const debouncedFetchData = useCallback(
    debounce(() => {
      dispatch(getAllCategoryNoLimit());
      dispatch(getCategoryTypesNoLimit());
      dispatch(getAllSubCatWithNoLimit());
      dispatch(getAllVendorsWithoutPagination());
      dispatch(getAllDepartments());
    }, 40),
    [],
  );

  useEffect(() => {
    debouncedFetchData();
  }, []);

  useEffect(() => {
    dispatch(getUsersUnderDepartment(departmentId));
  }, [departmentId]);

  useEffect(() => {
    if (pageNum && gridSize) {
      if (isResettingPage.current) {
        if (pageNum == 1) {
          dispatch(getSale(dispatchParams));
        }
        isResettingPage.current = false;
        return;
      } else {
        dispatch(getSale(dispatchParams));
      }
    }
  }, [
    gridSize,
    pageNum,
    search,
    typeId,
    categoryId,
    subCatId,
    poductSts?.id,
    vendorId,
    approvalSts,
    deliverySts,
    departmentId,
    userId,
  ]);

  const handleChange = (name, id) => {
    if (name == 'typeId') {
      setTypeId(id || null);
    } else if (name == 'categoryId') {
      setCategoryId(id || null);
    } else if (name == 'subCategoryId') {
      setSubCatId(id || null);
    } else if (name == 'vendorId') {
      setVendorId(id || null);
    } else if (name == 'departmentId') {
      setDepartmentId(id || null);
    } else if (name == 'userId') {
      setUserId(id || null);
    }
  };

  // Export should include every record matching the current filters, not only the visible page
  const fetchAllSalesForExport = async () => {
    const { typeId, categoryId, subCatId, damageStatus, vendorId, approvalStatus, deliveryStatus, departmentId, userId } =
      dispatchParams;
    const totalRecords = saleDetails?.meta?.totalRecords || 0;
    const paginationUrl = getPaginationUrl({ ...paginationData, pageNum: 1, gridSize: totalRecords || 1 });
    const res = await apiRequest({
      method: 'get',
      url: `sales-management/get-approved-requests${paginationUrl}&subCategory=${subCatId}&category=${categoryId}&type=${typeId}&isDamaged=${damageStatus}&vendorID=${vendorId}&approvalStatus=${approvalStatus}&deliveryStatus=${deliveryStatus}&departmentId=${departmentId}&userId=${userId}`,
    });
    return res?.data || [];
  };

  return (
    <GlobalWrapper title={'Requested / Delivered Items'}>
      <Box mb={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={typeId}
                fullWidth
                options={categoryTypesNoLimit}
                getOptionLabel={(option) => option.category_type_name || ''}
                value={categoryTypesNoLimit.find((d) => d.category_type_id == typeId) || null}
                onChange={(e, option) => handleChange('typeId', option?.category_type_id)}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Type Filter" />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={'categoryId'}
                fullWidth
                options={categoryAllData?.data || []}
                getOptionLabel={(option) => option.category_name || ''}
                value={categoryAllData?.data?.find((d) => d.category_id == categoryId) || null}
                onChange={(e, option) => handleChange('categoryId', option?.category_id)}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Category Filter" />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={'subCategoryId'}
                fullWidth
                options={allSubCatData}
                getOptionLabel={(option) => option.sub_category_name || ''}
                value={allSubCatData?.find((d) => d.sub_category_id == subCatId) || null}
                onChange={(e, option) => handleChange('subCategoryId', option?.sub_category_id)}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Sub Category Filter" />
                )}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={'vendorId'}
                fullWidth
                options={vendorData?.data || []}
                getOptionLabel={(option) => option.name || ''}
                value={vendorData?.data?.find((d) => d.vendorID == vendorId) || null}
                onChange={(e, option) => handleChange('vendorId', option?.vendorID)}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Vendor Filter" />
                )}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: 'id', itemValue: 'name' }}
                data={productStatus}
                label={'Product Status'}
                fullWidth={true}
                selectedDetails={poductSts}
                setChange={setProductSts}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: 'id', itemValue: 'name' }}
                data={approvalStatuses}
                label={'Approval Status'}
                fullWidth={true}
                selectedDetails={approvalSts}
                setChange={setApprovalSts}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: 'id', itemValue: 'name' }}
                data={deliveryStatuses}
                label={'Delivery Status'}
                fullWidth={true}
                selectedDetails={deliverySts}
                setChange={setDeliverySts}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={'departmentId'}
                fullWidth
                options={departments || []}
                getOptionLabel={(option) => option.dept_name || ''}
                value={departments?.find((d) => d.dept_id == departmentId) || null}
                onChange={(e, option) => handleChange('departmentId', option?.dept_id)}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Department Filter" />
                )}
              />
            </Box>
          </Grid>
          {true && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Box>
                <Autocomplete
                  name={'userId'}
                  fullWidth
                  options={usersUnderDepartment || []}
                  getOptionLabel={(option) => option.name || ''}
                  value={usersUnderDepartment?.find((d) => d.userID == userId) || null}
                  onChange={(e, option) => handleChange('userId', option?.userID)}
                  renderInput={(params) => (
                    <TextField disabled fullWidth autoComplete="off" {...params} label="User Filter" />
                  )}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box>
        <Paper>
          {currentRowDetails?.buyerName && (
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
              <strong>{`${currentRowDetails?.buyerName} - ${currentRowDetails?.subCategoryName} `}</strong>
            </Typography>
          )}
          <GlobalDatagrid
            tableHead={RequirementTableHeader({ procurement: true })}
            rows={saleDetails?.data}
            meta={saleDetails?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            setCurrentRowDetails={setCurrentRowDetails}
            exportAllRows={fetchAllSalesForExport}
            actionComponent={
              <>
                <ActionDetails val={rowData?.subCategoryName} />
                {rowData?.isProcurementHead && (
                  <>
                    <GlobalAnchorList
                      label={'Action'}
                      component={
                        <ProcureHeadApproval
                          dispatchParams={dispatchParams}
                          loading={loading}
                          saleId={rowData?.salesID}
                          disable={rowData?.isProcurementHeadApproved != 0}
                        />
                      }
                    />
                    <GlobalAnchorList
                      label={'Action'}
                      component={
                        <ProcureHeadReject
                          dispatchParams={dispatchParams}
                          loading={loading}
                          saleId={rowData?.salesID}
                          disable={rowData?.isProcurementHeadApproved != 0}
                        />
                      }
                    />
                  </>
                )}
                <GlobalAnchorList
                  component={
                    <DeliveryDate
                      dispatchParams={dispatchParams}
                      rowData={rowData}
                      notPendingStage={rowData?.deliveryStatus != 0}
                    />
                  }
                />
                <GlobalAnchorList
                  component={
                    <VerifyAndSale
                      dispatchParams={dispatchParams}
                      row={rowData}
                      notPendingStage={rowData?.deliveryStatus != 0}
                    />
                  }
                />
                {rowData?.is_returnable == 1 && (
                  <GlobalAnchorList
                    component={
                      <HandTheProductBack
                        dispatchParams={dispatchParams}
                        row={rowData}
                        notDelivered={rowData?.deliveryStatus != 1}
                      />
                    }
                  />
                )}
                <GlobalAnchorList
                  component={<ChangeDeliveredProduct dispatchParams={dispatchParams} row={rowData} />}
                />
                <GlobalAnchorList
                  label={''}
                  component={<ChangeUser dispatchParams={dispatchParams} saleId={rowData?.salesID} />}
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default SaleView;
